import { gql } from '@apollo/client';

const GET_READ_ALOUD = gql`
  query getReadAloud($readActivityWhere: ReadActivityWhereInput!) {
    readAloud(where: $readActivityWhere) {
      instructions {
        id
        src
        description
        vtt
      }
      book {
        id
        bookCode
        type
        characters {
          id
          character
          characterCase
          characterType
        }
        path
        offset
        totalPages
      }
      pages {
        contents {
          src
          description
          captions
        }
        page {
          id
          pageNumber
          src
        }
      }
    }
  }
`;

export default GET_READ_ALOUD;
